import type { GetEventFieldsResponse } from '@vy/api-definition';
import { GetEventFieldsResponseSchema } from '@vy/api-definition';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';
import { queryKeys } from '../../services/query-key/query-keys';

export function useEventFields(eventName: string, options?: CustomUseQueryOptions<GetEventFieldsResponse>) {
  return useQuery(
    queryKeys.eventFields(eventName),
    async () => {
      const privateApi = getPrivateApi();
      const getEventFieldsResponse = await privateApi.getEventFields({
        eventName,
      });

      return GetEventFieldsResponseSchema.parse(getEventFieldsResponse);
    },
    options,
  );
}
